// ToulouseSignature - Composant signature "Fait avec le ❤️ à Toulouse"
// Design glassmorphism avec cœur Lucide simple
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

// Composant principal ToulouseSignature
const ToulouseSignature = ({ variant = 'hero', className = '' }) => {
  const isHero = variant === 'hero';
  const isFooter = variant === 'footer';
  
  return (
    <motion.div 
      className={`toulouse-signature group ${className}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      whileHover={{ scale: 1.02 }}
    >
      {/* Badge pilule avec glassmorphism */}
      <div 
        className={`
          inline-flex items-center gap-2 
          px-5 py-2.5 
          rounded-full
          border border-cyan-400/20
          transition-all duration-300
          group-hover:border-cyan-400/40
          group-hover:shadow-[0_0_20px_rgba(0,245,255,0.15)]
          ${isFooter ? 'bg-void/60' : ''}
        `}
        style={{
          background: 'rgba(255, 255, 255, 0.03)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
        }}
      >
        {/* Texte "Fait avec le" */}
        <span 
          className={`
            font-sans font-light tracking-wide
            text-gray-400
            group-hover:text-gray-300
            transition-all duration-300
            ${isHero ? 'text-sm' : 'text-xs'}
          `}
          style={{ fontFamily: "'Inter', 'Montserrat', sans-serif" }}
        >
          Fait avec le
        </span>
        
        {/* Cœur Lucide simple */}
        <motion.div
          className="relative"
          animate={{ 
            scale: [1, 1.1, 1],
          }}
          transition={{ 
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          whileHover={{
            scale: 1.2,
            transition: { duration: 0.2 }
          }}
        >
          <Heart 
            className={`${isHero ? 'w-6 h-6' : 'w-5 h-5'} text-red-500 fill-red-500`}
            style={{ 
              filter: 'drop-shadow(0 0 6px rgba(239, 68, 68, 0.6))'
            }}
          />
        </motion.div>
        
        {/* Texte "à" */}
        <span 
          className={`
            font-sans font-light
            text-gray-400
            group-hover:text-gray-300
            transition-all duration-300
            ${isHero ? 'text-sm' : 'text-xs'}
          `}
          style={{ fontFamily: "'Inter', 'Montserrat', sans-serif" }}
        >
          à
        </span>
        
        {/* Toulouse - Style signature */}
        <motion.span 
          className={`
            font-orbitron font-bold
            text-cyan-400
            transition-all duration-300
            group-hover:text-cyan-300
            ${isHero ? 'text-base' : 'text-sm'}
          `}
          style={{ 
            textShadow: '0 0 10px rgba(0, 245, 255, 0.5)',
            letterSpacing: '0.05em'
          }}
          whileHover={{
            textShadow: '0 0 20px rgba(0, 245, 255, 0.8)',
          }}
        >
          Toulouse
        </motion.span>
      </div>
    </motion.div>
  );
};

export { ToulouseSignature };
export default ToulouseSignature;
